import { Utility } from "../utility.js";
import { Outdoor } from "./outdoor.js";

export class GreetNeighbors extends Outdoor{
    static info = {
        key: "greet-neighbors",
        name: "Greet Neighbors at LNY Block Party",
        description: "Lunar New Year is a time for sharing good fortune and celebrating togetherness. Visit your neighbors and wish them a Happy New Year!  You may even collect some lucky red envelopes!",
        logo: { x: 640, y: 520 },
        won: false
    }
    constructor(key, level){
        super(key, level, { holder: false, bobInRed: true })
        this._decorHangers = [
            {
                "name": "gnl-lantern-display-completed-1",
                "position": {"left": 1643, "top": 671},
            },
            {
                "name": "gnl-lantern-display-completed-2",
                "position": {"left": 799, "top": 1469},
            },
            {
                "name": "gnl-lantern-display-completed-3",
                "position": {"left": 2716, "top": 1472},
            },
            {
                "name": "gnl-lantern-display-completed-4",
                "position": {"left": 1884, "top": 2294},
            },
            {
                "name": "gnl-lion",
                "position": {"left": 1191, "top": 2000},
            }
        ]
        this._homie = [
            {
                "name": "gnl-adult-grandma",
                "position": {"left": 1650, "top": 1360},
                "partner": null,
                "greeting": "Happy New Year!",
                "bobGreet": "Wishing you good health and prosperity in the New Year!",
                "greeted": false,
                "giveEnvelope": true
            },
            {
                "name": "gnl-adult-man",
                "position": {"left": 480, "top": 1423},
                "partner": null,
                "greeting": "May the new year be full of abundance and good fortune!",
                "bobGreet": "Happy New Year!",
                "greeted": false,
                "giveEnvelope": true
            },
            {
                "name": "gnl-adult-woman",
                "position": {"left": 3500, "top": 1509},
                "partner": null,
                "greeting": "Happy New Year!",
                "bobGreet": "Wishing you joy and fun for the whole family!!",
                "greeted": false,
                "giveEnvelope": true
            },
            {
                "name": "gnl-kid-1",
                "position": {"left": 2256, "top": 780},
                "partner": "gnl-kid-2",
                "greeting": "Wishing you good fortune in the new year!!",
                "bobGreet": "Happy New Year to you, too!",
                "greeted": false,
                "giveEnvelope": false
            },
            {
                "name": "gnl-kid-2",
                "position": {"left": 2385, "top": 795},
                "partner": "gnl-kid-1",
                "greeting": "Happy New Year!",
                "bobGreet": "Happy New Year to you, too!",
                "greeted": false,
                "giveEnvelope": false
            },
            {
                "name": "gnl-kid-4",
                "position": {"left": 1580, "top": 2263},
                "partner": null,
                "greeting": "Happy Year of the Rabbit!",
                "bobGreet": "Happy New Year to you, too!",
                "greeted": false,
                "giveEnvelope": false
            },
            {
                "name": "gnl-kid-5",
                "position": {"left": 2016, "top": 1685},
                "partner": null,
                "greeting": "Happy New Year!",
                "bobGreet": "Happy New Year to you, too!",
                "greeted": false,
                "giveEnvelope": false
            }
        ]
        this._fireworks = [
            {
                anim: "fireworks1",
                x: 1564,
                y: 195,
                start: 0.9,
                animProps: {key: "fireworks1", start: 0, end: 9, frameRate: 4}
            },
            {
                anim: "fireworks2",
                x: 422,
                y: 629,
                start: 0.5,
                animProps: {key: "fireworks2", start: 10, end: 19, frameRate: 10}
            },
            {
                anim: "fireworks3",
                x: 397,
                y: 2035,
                start: 0.7,
                animProps: {key: "fireworks3", start: 10, end: 19, frameRate: 6}
            },
            {
                anim: "fireworks4",
                x: 2560,
                y: 1152,
                start: 0.3,
                animProps: {key: "fireworks4", start: 10, end: 19, frameRate: 8}
            },
            {
                anim: "fireworks5",
                x: 3711,
                y: 1552,
                start: 0.2,
                animProps: {key: "fireworks5", start: 10, end: 19, frameRate: 12}
            }
        ]
        this._homieGroup = null
        this._homieBubble = {container: null, started: null}
        this._evnelopeBubble = {container: null, started: null}
        this._totalStars = null
    }
    preload(){
        super.preload()
        this._decorHangers.forEach(h => this.load.image(h.name, `assets/greet-neighbors/decor-hangers/${h.name}.png`))
        this._homie.forEach(d => this.load.image(d.name, `assets/greet-neighbors/homie/${d.name}.png`))
        this.load.image("envelope", "assets/greet-neighbors/gnl-red-envelope-received.png")

        this.load.spritesheet("fireworks", "assets/greet-neighbors/gnl-fireworks-sprite.png", {
            frameWidth: 236,
            frameHeight: 236
        })
    }
    create(){
        super.create()
        this.doFireworks()
        let staticDecorHangers = this.physics.add.staticGroup()
        this._decorHangers.forEach(a => {
                let so = staticDecorHangers.create(a.position.left, a.position.top, a.name).setOrigin(0, 0).refreshBody()
                so.setSize(so.body.width, so.body.height - 145, false)
        })
        this._homieGroup = this.physics.add.staticGroup()
        this._homie.forEach(a => {
            this._homieGroup.create(a.position.left, a.position.top, a.name).setOrigin(0, 0).refreshBody()
        })
        this.physics.add.collider(this.bob, [staticDecorHangers, this._homieGroup])
        this.peiPeiSay("Go and wish your neighbours a happy new year!")

        this._totalStars = (this._homieGroup.children.entries.length-1) * this._GAME_ACTION_POINT + this._homie.filter(h => h.giveEnvelope === true).length * 3
        this.board.score.setText(`0/${this._totalStars}`)
    }
    update(time, delta){
        super.update(time, delta)
        this.updateHomieBubble()
        this.updateEnvelopeBubble()
    }
    onSpace(){
        const overlaps = this._homieGroup.children.entries.filter(d => this.physics.overlapRect(d.x-30, d.y-30, d.width+60, d.height+60, true, false).length !== 0)
        if (overlaps.length !== 1) return
        const greetObject = this._homie.filter(h => h.name === overlaps[0].texture.key)
        let score = this.board.score.text
        this.homieSay(greetObject[0].greeting, overlaps[0].body.center.x, overlaps[0].body.center.y)
        this.physics.pause()
        if (greetObject[0].partner) {
            let partner = this._homieGroup.children.entries.filter(p => greetObject[0].partner === p.texture.key)
            let partnerObject = this._homie.filter(h => h.name === greetObject[0].partner)  
            this.time.addEvent({ delay: 2000, callback: ()=> {this.homieSay(partnerObject[0].greeting, partner[0].body.center.x, partner[0].body.center.y)}, callbackScope: this })
            partnerObject[0].greeted = true
            partnerObject[0].giveEnvelope = false
        }
        this.time.addEvent({ delay: (greetObject[0].partner) ? 4000 : 2000, callback: ()=> {
            this.physics.resume()
            if (greetObject[0].greeted) return
            greetObject[0].greeted = true
            if(greetObject[0].giveEnvelope) {
                this.getEnvelope()
                this.peiPeiSay("Nice! You got a Red Envelope! These are traditionally gifted by elders.")
                this.sound.play("find-object")
                this.board.score.setText(`${parseInt(score) + 8}/${this._totalStars}`)
            }else{
                this.board.score.setText(`${parseInt(score) + 5}/${this._totalStars}`)
            }
            let result = this._homie.filter(i => i.greeted === false)
            if (result.length === 0) {this.win(this.board.score.text, this._level.current.index + 1); this.peiPeiSay("Mission Accomplished!")}
            if(this.bob) {this.say(greetObject[0].bobGreet); this.sound.play("speech")}

        }, callbackScope: this })
    }
    getEnvelope(){
        let icon = this.add.image(30,15, "envelope")
        let w = icon.width
        if (this._evnelopeBubble.container) this._evnelopeBubble.container.destroy()
        this._evnelopeBubble.container = this.add.container(this.bob.body.center.x - w/4, this.bob.y-270).setDepth(140)
        this._evnelopeBubble.container.add([icon])
        this._evnelopeBubble.started = Date.now()
    }
    updateEnvelopeBubble(){
        if(!this.bob) return
        let b = this._evnelopeBubble
        if (!b.container) return
        b.container.x = this.bob.body.center.x - b.container.width/4 - 30
        b.container.y = this.bob.y - 300
        if (Date.now() - b.started > 2000) {
            b.container.destroy()
            b.container = null
        }
    }
    homieSay(msg, x, y) {
        let text = Utility.make.text(this, 30, 15, msg,  {
            fontSize: "40px"
        })
        let w = text.width + 60
        let panel = this.add.graphics()
            .fillStyle(0x070b34, 1)
            .fillRoundedRect(0, 0, w, 80, 20)
        if (this._homieBubble.container) this._homieBubble.container.destroy()
        this._homieBubble.container = this.add.container(x - w/2, y - 200).setDepth(220)
        this._homieBubble.container.width = w
        this._homieBubble.container.height = 80
        this._homieBubble.container.add([panel, text])
        this.sound.play("speech")
        this._homieBubble.started = Date.now()
    }
    updateHomieBubble(){
        let b = this._homieBubble
        if (!b.container) return
        if (Date.now() - b.started > 2000) {
            b.container.destroy()
            b.container = null
        }
    }
    doFireworks(){
        this._fireworks.forEach(s => {
            this.anims.create({
                key: `${s.animProps.key}`,
                frames: this.anims.generateFrameNumbers("fireworks", {start: s.animProps.start, end: s.animProps.end}),
                frameRate: s.animProps.frameRate,
                repeat:-1
            })
            setTimeout(() => {
                this.add.sprite(s.x, s.y, "fireworks").play(s.anim)
            }, s.start)
        })
    }
}